import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { Box, BoxProps } from '../box';
import { spacing } from '../../style';

interface ColumnsGridProps extends BoxProps {
  spacing?: keyof typeof spacing;
}

const ColumnsGrid = styled(({ className, ...rest }: ColumnsGridProps) => (
  <Box className={classNames(className, 'box-grid')} flexWrap={'wrap'} display={'flex'} {...rest} />
))<ColumnsGridProps>`
  ${props =>
    props.spacing &&
    css`
      > .column {
        padding-left: ${spacing[props.spacing || 'none']};
        padding-top: ${spacing[props.spacing || 'none']};
      }

      margin-top: -${spacing[props.spacing || 'none']};
      margin-left: -${spacing[props.spacing || 'none']};
      width: calc(${props.width || '100%'} + ${spacing[props.spacing]});
    `}
`;

export default ColumnsGrid;
